import React, { useState } from 'react';
import { X, Gift } from 'lucide-react';

const SpecialOfferBanner = ({ onGetQuote }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="relative py-3 px-6" style={{ backgroundColor: '#00B3B3' }}>
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 flex-wrap">
        {/* Gift Icon */}
        <Gift className="w-6 h-6 text-white hidden sm:block" />
        
        {/* Offer Text */}
        <div className="text-center">
          <p className="text-white font-bold text-sm sm:text-base">
            🎉 Special Offer: <span className="underline">$10 OFF</span> your first repair + <span className="underline">FREE screen protector</span> with any screen replacement!
          </p>
        </div>

        {/* CTA Button */}
        <button
          onClick={onGetQuote}
          className="bg-white text-gray-900 px-4 py-1.5 rounded-full font-bold text-sm hover:bg-gray-100 transition-colors whitespace-nowrap"
        >
          Claim Offer
        </button>

        {/* Close Button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center hover:bg-white/20 rounded-full transition-colors"
          aria-label="Close banner"
        >
          <X className="w-4 h-4 text-white" />
        </button>
      </div>
    </div>
  );
};

export default SpecialOfferBanner;
